// Enums translated from proto Obstacle definitions

// 障碍物类型枚举，表示感知到的对象分类
export enum ObstacleType {
  MISC = 0, // 其他类型
  CAR = 1, // 小轿车
  PEDESTRIAN = 2, // 行人
  CYCLIST = 3, // 自行车
  TRUCK = 4, // 卡车
  BUS = 5, // 公交车
  POINT_CLOUD_CLUSTER = 6, // 点云聚类（未识别物体）
  ARTIFICIAL_VARIABLE_OBJECT = 7, // 人工可变物体
  TRAFFIC_CONE = 8, // 交通锥
  LOW_PROFILE_OBSTACLE = 9, // 低矮障碍物
  ROAD_SEWER = 10, // 道路井盖
  STATIC_NON_MOTOR = 11, // 静态非机动车
  WATER_BARRIER = 12, // 水马/防水隔离
  TRICYCLE = 13, // 三轮车
  CYCLIST_STOPPED = 14, // 静止自行车
  POLE = 15, // 立柱/杆
  JD_VEHICLE = 16, // 京东车辆（自定义分类）
  OTHERS_VEHICLE = 17, // 其他车辆
  IMAGE_OCC = 18, // 图像占用区域（图像占据区域）
}

// 障碍物行为意图枚举，用于表征障碍物当前的行为趋势
export enum BehaviorIntention {
  UNKNOWN_BEHAVIOR = 0, // 未知行为
  STARTING = 1, // 正在启动
  STOPPING = 2, // 正在停止
  REVERSING = 3, // 正在倒车
  INTERMITTENT = 4, // 间歇运动
  GATE_FRONT = 5, // 前方为闸机相关动作
  GATE_BEHIND = 6, // 后方为闸机相关动作
  GATE_CROSSING = 7, // 正在通过闸机
}

// 静态状态分类，用于标注静态但语义明确的对象状态
export enum StaticStatus {
  UNKNOWN_STATIC = 0, // 未知静态状态
  BLOCK_ROAD_VEHICLE = 1, // 阻塞道路的车辆
  WAIT_TRAFFIC_LIGHT = 2, // 等待交通灯
}

// 交互意图枚举，用于描述与 Ego 车辆/其他车辆的交互关系
export enum InteractionIntention {
  UNKNOWN_INTERACTION = 0, // 未知交互意图
  FOLLOW = 1, // 跟随
  ACCOMPANYING_LEFT = 2, // 左侧伴随
  ACCOMPANYING_RIGHT = 3, // 右侧伴随
  OVERTAKE_LEFT = 4, // 左侧超车
  OVERTAKE_RIGHT = 5, // 右侧超车
  CUTIN_LEFT = 6, // 左侧切入
  CUTIN_RIGHT = 7, // 右侧切入
}

// 运动意图枚举，表示预期的运动动作
export enum MotionIntention {
  UNKNOWN_MOTION = 0, // 未知运动意图
  RIGHT_TURN = 1, // 右转
  LEFT_TURN = 2, // 左转
  KEEP_STRAIGHT = 3, // 直行
  U_TURN = 4, // 掉头
  LANE_CHANGE_RIGHT = 5, // 向右变道
  LANE_CHANGE_LEFT = 6, // 向左变道
}

// 障碍物意图组合枚举，用于以位集合/重复字段表示多重意图
export enum IntentType {
  UNKNOWN_INTENT = 0, // 未知意图
  LEFT_INTENT = 1, // 左转意图
  STRAIGHT_INTENT = 2, // 直行意图
  RIGHT_INTENT = 3, // 右转意图
  STOP_INTENT = 4, // 停止意图
  START_INTENT = 5, // 启动意图
  REVERSING_INTENT = 6, // 倒车意图
  INTERMITTENT_INTENT = 7, // 间歇性运动意图
}

// ObstacleIntent message 对应的本地接口（包含重复的 intent 列表）
export interface ObstacleIntent {
  intent?: IntentType[]; // 意图集合（可重复/多选）
}

export enum GearState {
  OTHER = 0,
  NEUTRAL = 1,
  DRIVE = 2,
  REVERSE = 3,
  PARKING = 4,
  LOW = 5,
  INVALID = 6,
  NONE = 7,
  SPORT = 8,
}

export const GearStateMap: Record<GearState, string> = {
  [GearState.OTHER]: 'OTHER',
  [GearState.NEUTRAL]: 'NEUTRAL',
  [GearState.DRIVE]: 'DRIVE',
  [GearState.REVERSE]: 'REVERSE',
  [GearState.PARKING]: 'PARKING',
  [GearState.LOW]: 'LOW',
  [GearState.INVALID]: 'INVALID',
  [GearState.NONE]: 'NONE',
  [GearState.SPORT]: 'SPORT',
};

export default {
  ObstacleType,
  BehaviorIntention,
  StaticStatus,
  InteractionIntention,
  MotionIntention,
  IntentType,
};
